export default "__VITE_ASSET__BeBjsSzY__"